import { render, staticRenderFns } from "./todoMatchContactDialog.vue?vue&type=template&id=37532a2b&scoped=true"
import script from "./todoMatchContactDialog.vue?vue&type=script&lang=js"
export * from "./todoMatchContactDialog.vue?vue&type=script&lang=js"
import style0 from "./todoMatchContactDialog.vue?vue&type=style&index=0&id=37532a2b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37532a2b",
  null
  
)

export default component.exports